/**
 * reloadApp function
 * Performs a full document reload to pull the latest published build. Wrapped in
 * a single function so the reload behaviour lives in one place and can be mocked
 * in tests.
 *
 * @returns void
 */
export const reloadApp = (): void => {
  window.location.reload();
};
